export default __webpack_public_path__ + "static/media/Spinner.0bf563b7.gif";